
import React, { useMemo } from "react";
import { FlightSearchBar } from "./FlightSearchBar";

interface FlightPageHeaderProps {
  flightCount: number;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function FlightPageHeader({ flightCount, searchTerm, onSearchChange }: FlightPageHeaderProps) {
  const currentDate = useMemo(() => {
    return new Date().toLocaleDateString('en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }, []);

  return (
    <div className="flex flex-col gap-6 mb-6">      
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Flight Information</h1>
          <p className="text-foreground">{currentDate}</p>
        </div>
      
        <FlightSearchBar 
          searchTerm={searchTerm}
          onSearchChange={onSearchChange}
        />
      </div>
    </div>
  );
}
